module.exports = __webpack_public_path__ + "img/return.25166e9e.png";